function u(e, n) {
  return e.type === "submenu" || e.type === void 0 && e[n] !== void 0;
}
function i(e) {
  return e.type === "group";
}
function r(e) {
  return e.type === "divider";
}
function t(e) {
  return e.type === "render";
}
export {
  r as isDividerNode,
  i as isGroupNode,
  t as isRenderNode,
  u as isSubmenuNode
};
